import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../utils/scroll';
const points = [{
  n: '01',
  emoji: '😩',
  tag: 'Inseguridad',
  title: 'Llegas al pabellón sin saber exactamente qué vas a entrenar.',
  text: 'Improvisas sobre la marcha en lugar de seguir una progresión pensada de antemano.'
}, {
  n: '02',
  emoji: '📉',
  tag: 'Frustración',
  title: 'Tus jugadores no progresan de manera visible.',
  text: 'No tienes una secuencia clara de fundamento en fundamento y al final de la temporada no sabes si han mejorado realmente.'
}, {
  n: '03',
  emoji: '🔄',
  tag: 'Estancamiento',
  title: 'Siempre los mismos 10 o 15 ejercicios.',
  text: 'Repites lo mismo porque no tienes más material listo, y los jugadores llegan al entrenamiento sin ilusión.'
}, {
  n: '04',
  emoji: '👥',
  tag: 'Agobio',
  title: 'No sabes cómo adaptar el entrenamiento a distintos niveles.',
  text: 'Tienes jugadores muy distintos en el mismo equipo y no sabes cómo dar un ejercicio que funcione para todos.'
}, {
  n: '05',
  emoji: '😨',
  tag: 'Miedo',
  title: 'Sientes inseguridad técnica cuando tienes que corregir.',
  text: 'Te cuesta saber exactamente qué le tienes que decir al jugador para que mejore su tiro o su defensa.'
}, {
  n: '06',
  emoji: '💼',
  tag: 'Aspiración',
  title: 'Quieres que te reconozcan como un entrenador profesional.',
  text: 'Buscas ofrecer un sistema serio y estructurado, con una progresión clara detrás de cada sesión.'
}];
export function ForYou() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-91" data-mp="guiod9xni0if">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-92" data-mp="vq83co4f5ddn">
        <SectionTag icon="👀" data-id="element-93" data-mp="qrwt4ca7p0uw">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-94" data-mp="qthno1wj0jsr">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-95" data-mp="12tg01bw8l1i3">
          Si te identificas con 2 o más, EL MANUAL DEL ENTRENADOR fue diseñado exactamente para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-96" data-mp="1ckamag9hg13j">
        {points.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="relative flex flex-col rounded-2xl border border-white/10 bg-bg-primary p-6" data-id="element-97" data-mp="1hiubqqnabv0n" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-98" data-mp="3sboo69olgw9s">
              <span className="font-heading text-3xl font-bold text-white/10" data-id="element-99" data-mp="3sdhybyyf1ymj">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-100" data-mp="16yghzu5x8eq">
                {point.emoji}
              </span>
            </div>
            <span className="mt-3 inline-block w-fit rounded-full bg-orange/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-orange" data-id="element-101" data-mp="3l0acdaeatsi6">
              {point.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-white" data-id="element-102" data-mp="3b2cqgtjww7sq">
              {point.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-103" data-mp="cjozhiijqf9s">{point.text}</p>
            <div className="mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-success/15" data-id="element-104" data-mp="7mff4ha0ktst">
              <CheckIcon size={14} className="text-success" data-id="element-105" data-mp="2kpz0n7xppxv" />
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 text-center sm:px-6" data-id="element-106" data-mp="3ts2m1ivi0xlp">
        <p className="text-base leading-relaxed text-white sm:text-lg" data-id="element-107" data-mp="2nd1lezvj3r8s">
          Entrena con la seguridad de quien llega al pabellón sabiendo exactamente qué quiere trabajar y
          cómo hacerlo.
        </p>
        <div className="mt-6 flex justify-center" data-id="element-108" data-mp="b0dyu4obadjo">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-109" data-mp="fsf7zhq6no5h">Quiero el manual del entrenador</PrimaryButton>
        </div>
      </div>
    </section>;
}